// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1Xuim","name":"ConsentHeader_name__1fPC6","birthday":"ConsentHeader_birthday__1oTHI","skeleton":"ConsentHeader_skeleton__1vQVP"};